import styled from 'styled-components';
import { bounceFromUp } from '../Main/Main.style';

export const Warper = styled.div`
  animation: ${bounceFromUp} 1s ease-in-out;
  .fc-direction-ltr {
    max-height: 88vh;
  }
`;
